import { Component, OnDestroy, OnInit } from '@angular/core';
import { IGetMenuInitResponse, InitDataClient, SubscriptionPackage, TipPristupa } from '@kodit/core/data-api';
import { AuthService, NotificationService, STRANKA_CLAIMS } from '@kodit/core/services';
import { Subscription } from 'rxjs';

interface MenuItem {
  label?: string;
  icon?: string;
  routerLink?: string[];
  items?: MenuItem[];
  separator?: boolean;
  isVisible?: boolean;
  notification?: any;
  onClick?: () => void;
}

@Component({
  selector: 'kodit-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit, OnDestroy {
  model: any[];
  menuItems: MenuItem[] = [];
  racunStatusNof: number;
  private _subs: Subscription = new Subscription();

  constructor(
    private _authService: AuthService,
    private _notificationService: NotificationService,
    private _client: InitDataClient
  ) {}

  ngOnInit() {
    this._loadInit();

    this._subs.add(
      this._authService.getUserChanged.subscribe((res) => {
        if (res) {
          this._loadInit();
        }
      })
    );

    this._subs.add(
      this._authService.getPackagesChanged.subscribe(() => {
        this._loadInit();
      })
    );
  }

  // onMenuClick(event: any) {
  //   this.app.onMenuClick(event);
  // }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

  private _menuNotificationsSub() {
    this._subs.add(
      this._notificationService.getRacunStatusChangeNotification.subscribe(
        (res) => {
          this.racunStatusNof = res;
        }
      )
    );
  }

  private _setMenuItems(initData: IGetMenuInitResponse) {
    this.menuItems = [
      // racuni
      {
        label: 'Dokumenti',
        icon: 'fas fa-file-alt',
        isVisible:
          this._authService.hasPackage([
            SubscriptionPackage[SubscriptionPackage.EFAKTURE],
            SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
            SubscriptionPackage[SubscriptionPackage.BESPLATNO],
          ]) &&
          this._authService.hasClaim([
            TipPristupa[TipPristupa.IZLAZNA_FAKTURA_VIEW],
            TipPristupa[TipPristupa.AVANSNI_RACUN_VIEW],
            TipPristupa[TipPristupa.IZMENA_OSNOVICE_VIEW],
            TipPristupa[TipPristupa.ULAZNA_FAKTURA_VIEW],
            TipPristupa[TipPristupa.PREDRACUN_VIEW],
            TipPristupa[TipPristupa.PDV_VIEW],
          ]),
        items: [
          {
            label: this._authService.hasInfoZgrada()
              ? 'Računi'
              : 'Izlazni računi',
            icon: 'fa-solid fa-file-arrow-up',
            routerLink: ['racuni', 'izlazni-racuni'],
            isVisible:
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.EFAKTURE],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.IZLAZNA_FAKTURA_VIEW]
              ),
            // notification: () => {
            //   return this.racunStatusNof;
            // },
          },
          {
            label: this._authService.hasInfoZgrada()
              ? 'Troškovi'
              : 'Ulazni računi',
            icon: 'fa-solid fa-file-arrow-down',
            routerLink: ['racuni', 'ulazni-racuni'],
            isVisible:
              (this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.EFAKTURE],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) ||
                this._authService.hasPackage(
                  SubscriptionPackage[SubscriptionPackage.BESPLATNO]
                )) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.ULAZNA_FAKTURA_VIEW]
              ),
          },
          {
            label: 'Predračuni',
            icon: 'fa-solid fa-file',
            routerLink: ['racuni', 'predracuni'],
            isVisible:
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.EFAKTURE],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.PREDRACUN_VIEW]
              ) &&
              !this._authService.hasInfoZgrada(),
          },
          {
            label: 'Ponude',
            icon: 'fa-solid fa-file-contract',
            routerLink: ['racuni', 'ponude'],
            isVisible:
              initData.prikaziPonude &&
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.EFAKTURE],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.PREDRACUN_VIEW]
              ) &&
              !this._authService.hasInfoZgrada(),
          },
          {
            label: 'Pdv',
            icon: 'fa-solid fa-books',
            routerLink: ['dokumenti', 'pdv-evidencije'],
            isVisible:
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.EFAKTURE],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) &&
              this._authService.hasClaim(TipPristupa[TipPristupa.PDV_VIEW]) &&
              !this._authService.hasInfoZgrada(),
          },
          {
            label: 'Prethodni porez',
            icon: 'fa-solid fa-file-invoice',
            routerLink: ['dokumenti', 'sef-obavestenja'],
            isVisible:
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.EFAKTURE],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) &&
              this._authService.hasClaim(TipPristupa[TipPristupa.PDV_VIEW]) &&
              !this._authService.hasInfoZgrada(),
          },
        ],
      },

      // proizvodnja
      {
        label: 'Proizvodnja',
        icon: 'fa-regular fa-conveyor-belt-arm',
        isVisible:
          this._authService.hasPackage([
            SubscriptionPackage[SubscriptionPackage.PROIZVODNJA],
          ]) &&
          this._authService.hasClaim(TipPristupa[TipPristupa.RADNI_NALOG_VIEW]),
        items: [
          {
            label: 'Radni nalozi',
            icon: 'fa-solid fa-file-lines',
            routerLink: ['racuni', 'radni-nalozi'],
            isVisible:
              this._authService.hasClaim(
                TipPristupa[TipPristupa.RADNI_NALOG_VIEW]
              ) && !this._authService.hasInfoZgrada(),
          },
        ],
      },
      // maloprodaja
      {
        label: 'Maloprodaja',
        icon: 'fa-solid fa-money-check',
        isVisible:
          this._authService.hasPackage([
            SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
            SubscriptionPackage[SubscriptionPackage.FISKALNA_KASA],
          ]) &&
          this._authService.hasClaim(
            TipPristupa[TipPristupa.FISKALNI_RACUN_VIEW]
          ),
        items: [
          {
            label: 'Fiskalni računi',
            icon: 'fa-solid fa-cash-register',
            routerLink: ['maloprodaja', 'fiskalni'],
          },
        ],
      },
      // finansije (izvodi)
      {
        label: 'Finansije',
        icon: 'fa-solid fa-money-check',
        isVisible:
          this._authService.hasPackage([
            SubscriptionPackage[SubscriptionPackage.FINANSIJE],
          ]) && this._authService.hasClaim(TipPristupa[TipPristupa.IZVOD_CRUD]),
        items: [
          {
            label: 'Izvodi',
            icon: 'fa-solid fa-money-check',
            routerLink: ['banka', 'izvodi'],
          },
          {
            label: 'Uplate',
            icon: 'fa-solid fa-left-to-line',
            routerLink: ['banka', 'uplate'],
          },
          {
            label: 'Isplate',
            icon: 'fa-solid fa-right-to-line',
            routerLink: ['banka', 'isplate'],
          },
        ],
      },
      // robni proment / magacinsko poslovanje
      {
        label: 'Robni promet',
        isVisible:
          this._authService.hasPackage([
            SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
            SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
            SubscriptionPackage[SubscriptionPackage.EOTPREMNICE],
          ]) &&
          this._authService.hasClaim([
            TipPristupa[TipPristupa.ROBNI_PROMET_VIEW],
            TipPristupa[TipPristupa.MAGACIN_CRUD],
            TipPristupa[TipPristupa.OTPREMNICA_VIEW],
          ]),
        items: [
          {
            label: 'Slanje robe',
            icon: 'fa-regular fa-truck-arrow-right',
            routerLink: ['eotpremnice', 'slanje-robe'],
            isVisible:
              this._authService.hasPackage(
                SubscriptionPackage[SubscriptionPackage.EOTPREMNICE]
              ) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.OTPREMNICA_VIEW]
              ),
          },
            {
            label: 'Prijem robe',
            icon: 'fa-solid fa-boxes-stacked',
            routerLink: ['eotpremnice', 'prijem-robe'],
            isVisible:
              this._authService.hasPackage(
                SubscriptionPackage[SubscriptionPackage.EOTPREMNICE]
              ) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.OTPREMNICA_VIEW]
              ),
          },
          {
            label: 'Otpremnice',
            icon: 'fa-solid fa-file-chart-column',
            routerLink: ['racuni', 'otpremnice'],
            isVisible:
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.OTPREMNICA_VIEW]
              ),
          },
          {
            label: 'Magacini',
            icon: 'fa-solid fa-warehouse',
            routerLink: ['robno/magacini'],
            isVisible: this._authService.hasClaim([
              TipPristupa[TipPristupa.ROBNI_PROMET_VIEW],
              TipPristupa[TipPristupa.MAGACIN_CRUD],
            ]),
          },
          {
            label: 'Lager',
            icon: 'fa-solid fa-pallet-boxes',
            routerLink: ['robno/lageri'],
            isVisible:
              (this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) ||
                (this._authService.hasPackage(
                  SubscriptionPackage[SubscriptionPackage.EOTPREMNICE]
                ) &&
                  initData.pracenjeLageraZaEOtpremnice)) &&
              this._authService.hasClaim([
                TipPristupa[TipPristupa.ROBNI_PROMET_VIEW],
                TipPristupa[TipPristupa.MAGACIN_CRUD],
              ]),
          },
          {
            label: 'Kalkulacije',
            icon: 'fa-solid fa-tag',
            routerLink: ['robno/kalkulacije'],
            isVisible:
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
                SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
              ]) &&
              this._authService.hasClaim(
                TipPristupa[TipPristupa.ROBNI_PROMET_VIEW]
              ),
          },
        ],
      },
      // kompanija
      {
        label: 'Kompanija',
        icon: 'fa-solid fa-buildings',
        isVisible:
          this._authService.hasPackage([
            SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
            SubscriptionPackage[SubscriptionPackage.FISKALNA_KASA],
            SubscriptionPackage[SubscriptionPackage.EFAKTURE],
            SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
            SubscriptionPackage[SubscriptionPackage.BESPLATNO],
            SubscriptionPackage[SubscriptionPackage.EOTPREMNICE],
          ]) &&
          this._authService.hasClaim([
            TipPristupa[TipPristupa.STRANKA_CRUD],
            TipPristupa[TipPristupa.VOZILO_CRUD],
            TipPristupa[TipPristupa.CENOVNIK_CRUD],
            TipPristupa[TipPristupa.IZVESTAJ_VIEW],
          ]),
        items: [
          {
            label: 'Pravna lica',
            icon: 'fa-solid fa-buildings',
            routerLink: ['stranke', 'pravna-lica'],
            isVisible: this._authService.hasClaim(STRANKA_CLAIMS),
          },
          {
            label: this._authService.hasInfoZgrada()
              ? 'Stanari'
              : 'Fizička lica',
            icon: 'fa-solid fa-user-group',
            routerLink: ['stranke', 'fizicka-lica'],
            isVisible:
              this._authService.hasClaim(STRANKA_CLAIMS) &&
              (this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
                SubscriptionPackage[SubscriptionPackage.FISKALNA_KASA],
              ]) ||
                this._authService.hasAllOtherPackagesExcept(
                  SubscriptionPackage[SubscriptionPackage.BESPLATNO]
                )),
          },
          {
            label: 'Vozila',
            icon: 'fa-solid fa-truck',
            routerLink: ['kompanija/vozila'],
            isVisible: this._authService.hasAllOtherPackagesExcept([
              SubscriptionPackage[SubscriptionPackage.BESPLATNO],
              SubscriptionPackage[SubscriptionPackage.INFO_ZGRADA],
            ]),
          },
          {
            label: 'Cenovnici',
            icon: 'fa-solid fa-coins',
            routerLink: ['kompanija/cenovnici'],
            isVisible: this._authService.hasAllOtherPackagesExcept([
              SubscriptionPackage[SubscriptionPackage.BESPLATNO],
              SubscriptionPackage[SubscriptionPackage.INFO_ZGRADA],
            ]),
          },
          {
            label: 'Izveštaji',
            icon: 'fa-solid fa-magnifying-glass-chart',
            routerLink: ['kompanija/izvestaji'],
            isVisible:
              this._authService.hasClaim(
                TipPristupa[TipPristupa.IZVESTAJ_VIEW]
              ) ||
              this._authService.hasPackage([
                SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
                SubscriptionPackage[SubscriptionPackage.FISKALNA_KASA],
              ]) ||
              this._authService.hasAllOtherPackagesExcept([
                SubscriptionPackage[SubscriptionPackage.BESPLATNO],
                SubscriptionPackage[SubscriptionPackage.INFO_ZGRADA],
              ]),
          },
        ],
      },
      //Arhivska knjiga i datoteke
      {
        label: 'DMS',
        isVisible:
          this._authService.hasPackage([
            SubscriptionPackage[SubscriptionPackage.ARHIVA],
          ]) &&
          this._authService.hasClaim([
            TipPristupa[TipPristupa.ARHIVSKA_KNJIGA_VIEW],
          ]),
        items: [
          {
            label: 'Datoteke',
            icon: 'fa-solid fa-folder-open',
            routerLink: ['kompanija/file-manager'],
          },
          {
            label: 'Arhivska knjiga',
            icon: 'fas fa-light fa-folder-tree',
            routerLink: ['kompanija/arhivska-knjiga'],
          },
          {
            label: 'Delovodnik',
            icon: 'fa-regular fa-table',
            routerLink: ['kompanija/delovodnik'],
          },
        ],
      },
    ];
  }

  private _loadInit() {
    this._subs.add(
      this._client.getMenuInit().subscribe((res) => {
        this._setMenuItems(res.data);
      })
    );
  }
}
